<template>
    <div class="group-buttons"> 
      <span class="title-section">
        <span>
          <label :title="$t('utilities')">{{$t('utilities')}}</label>
        </span>
      </span>
      
      <b-button v-for="(btnProp, idx) in buttons.utils" 
      :key="idx+'-utils'" 
      :class="btnProp.class" 
      :title="$t(btnProp.title)" 
      @click="factoryCtrl(typesNodes[btnProp.typeNode]).setNewNode(openDialog)"
      >
        {{ $t(btnProp.text) }}
      </b-button>

      <span class="title-section">
        <span>
          <label :title="$t('operations')">{{$t('operations')}}</label>
        </span>
      </span>
      
      <b-button v-for="(btnProp, idx) in buttons.operations" 
      :key="idx+'-operation'" 
      :class="btnProp.class" 
      :title="$t(btnProp.title)" 
      @click="factoryCtrl(typesNodes[btnProp.typeNode[0]], btnProp.typeNode[1]).setNewNode(openDialog)">
        {{ $t(btnProp.text) }}
      </b-button>
      
      <span class="title-section">
        <span>
          <label :title="$t('areas')">{{$t('areas')}}</label>
        </span>
      </span>

      <b-button 
      class="color-buttons-areas" 
      :title="$t('jokerArea')" 
      @click="factoryCtrl(typesNodes.AreaJoker).setNewNode(openDialog, loadFlowchartTo)"> 
        {{$t('jokerArea')}}
      </b-button>

      <b-button v-for="(btnProp, idx) in buttons.areas" 
      :key="idx+'-area'" 
      :class="btnProp.class" 
      :title="$t(btnProp.title)" 
      @click="factoryCtrl(typesNodes.Area, btnProp.typeNode).setNewNode(openDialog, loadFlowchartTo)">
        {{ $t(btnProp.text) }}
      </b-button>

    </div>
</template>

<script>
import {NODES} from '../utils/buttons'

export default {
  name: "NodesButtons",
  props:[
    "factoryCtrl",
    "openDialog",
    "loadFlowchartTo",
    "typesNodes",
    "selectionArea"
  ],
  data(){
    return {
      buttons:NODES,
    }
  }
}
</script>
<style src="../index.css"></style>

